import React from 'react';
import {Box} from '@material-ui/core';
import {TabPanelProps} from './types';

const TabPanel = ({children}: TabPanelProps) => <Box style={{paddingTop: 10}}>{children}</Box>

export default TabPanel;
